module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pub-container"
  }, [_c('div', {
    staticClass: "pub-status"
  }, [_vm._v("\n        " + _vm._s(_vm.pubMsg) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "pub"
  }, [_c('div', {
    staticClass: "pub__visuel"
  }, [_c('img', {
    attrs: {
      "src": _vm.pubImageSrc,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pub__content"
  }, [_c('div', {
    staticClass: "pub__date"
  }, [_vm._v(_vm._s(_vm.pubDate))]), _vm._v(" "), _c('div', {
    staticClass: "pub__title"
  }, [_vm._v(_vm._s(_vm.pubTitle))]), _vm._v(" "), _c('div', {
    staticClass: "pub__offer"
  }, [_vm._v(_vm._s(_vm.pubOffer))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-06bedb76!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ad.vue
// module id = 32
// module chunks = 0